<!--
 * @Descripttion: 
 * @version: 
 * @Author: jing
 * @Date: 2020-12-11 18:32:14
 * @LastEditors: jing
 * @LastEditTime: 2020-12-15 15:29:40
-->

<template>
  <div id="splash" v-show="splash" @click="hideSplash">
    <img
      class="splash-img"
      src="http://assets.rurushishi.com/yq-rs-make/vcard3/splash.jpeg"
    />
    <div class="cutdown">{{ cutDown }}s跳过</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    // option: Object
  },
  data() {
    return {
      splash: true,
      cutDown: 3,
      timer: null
    };
  },
  watch: {},
  computed: {},
  methods: {
    hideSplash() {
      this.splash = false;
    }
  },
  created() {},
  mounted() {
    const _this = this;
    _this.timer = setInterval(() => {
      this.cutDown--;
      if (_this.cutDown == 0) {
        clearInterval(_this.timer);
        _this.splash = false;
      }
    }, 1000);
  }
};
</script>
<style lang="stylus" scoped>
#splash{
  position :fixed;
  top :0;
  left :0;
  z-index 20000;
  width :100%;
  height :100%;
  opacity :1;
  transition :opacity .3s ease;
  box-sizing :border-box;
  background-color :#0F5DA2;
}
.splash-img{
  width :100%;
  height 100%;
}
.cutdown{
  display :flex;
  justify-content :center;
  align-items:center;
  height :20px;
  border :1px solid #fff;
  border-radius:10px;
  padding :0 10px;
  position :fixed;
  top :12%;
  right :8%;
  background-color: rgba(0, 0, 0, 0.3);
  color: #ffffff;
  font-size :10px;

}
</style>
